export default __webpack_public_path__ + "static/media/cov-uni.82cac4ac.jpg";